import apiFetch from '../apiFetch'

export default function (token, documentId) {
  return apiFetch({ endPoint: `documentHistorical/${documentId}/info`, method: 'GET', body: null, token: token })
}
